export const setIdToFramework = (setId: string): string | null | undefined => {
    switch (true) {
        case setId.startsWith("CCSS"):
            return "Common Core";
        case setId.startsWith("NGSS"):
            return "Next Generation Science Standards";
        case setId.startsWith("AP"):
            return "Advanced Placement";
        case setId.startsWith("SAT"):
            return "Scholastic Aptitude Test";
        default:
            return null;
    }
};
